import clsx from "clsx";

type VerticalDividerProps = {
  color?: string;
  className?: string;
};

const VerticalDivider = ({ color, className }: VerticalDividerProps) => (
  <div
    className={clsx(
      "vertical-divider",
      color && `background-${color}`,
      className
    )}
  />
);

export default VerticalDivider;
